import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useNotifications } from '../lib/usefetchNotifications';
import { useNavigate } from 'react-router-dom';
import './notifications.css';

const timeAgo = (createdAt) => {
  const now = new Date();
  const diffMs = now - new Date(createdAt);
  const diffMins = Math.floor(diffMs / 60000);

  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins} min ago`;
  const diffHours = Math.floor(diffMins / 60);
  if (diffHours < 24) return `${diffHours} hours ago`;

  return new Date(createdAt).toLocaleString();
};

const Notifications = () => {
  const navigate = useNavigate();

  const {
    data,
    isLoading,
    isError,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useNotifications(10); // Limit set to 10

  const handleLoadMore = () => {
    if (hasNextPage) fetchNextPage();
  };

  const pages = data?.pages || [];
  const isNewNotification = (createdAt) => {
    return new Date() - new Date(createdAt) < 60 * 60 * 1000; // Less than 1 hour
  };

  const renderNotificationContent = () => {
    if (isLoading) {
  return (
        <div className="notification-card-container">
            {[...Array(3)].map((_, index) => (
            <div key={index} className="notification-skeleton">
              <Skeleton height={20} width={120} style={{ marginBottom: '8px' }} />
              <Skeleton height={16} width={300} style={{ marginBottom: '8px' }} />
              <Skeleton height={12} width={80} style={{ marginLeft: 'auto' }} />
              </div>
            ))}
          </div>
      );
    }

    if (isError) {
      return (
        <div className="no-notifications-message">
            <p>Error: {error.message}</p>
          </div>
      );
    }

    if (pages.length === 0 || (pages.length === 1 && pages[0].data.length === 0)) {
      return (
        <div className="no-notifications-message">
            <p>No notifications available</p>
          </div>
      );
    }

    return (
      <div className="notification-card-container">
            {pages.map((page, pageIndex) => (
              <React.Fragment key={pageIndex}>
                {page.data.map((notification) => (
                  <div
                    key={notification._id}
                    onClick={() => navigate(`/notification/${notification._id}`)}
                className="notification-item"
                  >
                <div className='notification-header-row'>
                  {isNewNotification(notification.createdAt) && (
                    <div className="notification-new-indicator"></div>
                      )}
                  <span className="notification-sender">{notification.userType}</span>
                    </div>
                <p className="notification-message">{notification.message}</p>
                <div className='notification-time'>
                  {timeAgo(notification.createdAt)}
                    </div>
                  </div>
                ))}
              </React.Fragment>
            ))}
      </div>
    );
  };

  return (
    <div className='notification-container'>
      <div className='notification-header'>
        <h1>Notifications</h1>
      </div>

      {renderNotificationContent()}

      {!isLoading && !isError && pages.length > 0 && pages[0].data.length > 0 && (
        <div className="load-more-container">
          <button 
            className="load-more-button"
            onClick={handleLoadMore} 
            disabled={!hasNextPage || isFetchingNextPage}
          >
            {isFetchingNextPage ? 'Loading...' : hasNextPage ? 'See More' : 'No More Notifications'}
            </button>
        </div>
      )}
    </div>
  );
};

export default Notifications;

